import elementExists from '../../../core/utils/element-exists';
import eventBus from '../../../core/services/event-bus';
import ProductJSON from './product-json';
import ProductClosureFilters from './product-closure-filters';
import ProductShrinkBands from './product-shrink-bands';

const ProductClosures = () => {
    const bundleParentInput = document.querySelector('[sh-bundle-parent]');
    const productClosuresContainer = document.querySelector('[product-closure-results]');
    const selectedClosureContainer = document.querySelector( '[product-closure-selected-closure]')
    let currentVariantMeta = null;
    let neckFinishPosition = false;
    let needsClosures = false;
    let neckFinishes = [];
    let { productData , currentVariant, productVariantMeta , productOptions  } = ProductJSON(2);
    let selectedClosure = false
    const submitButton = document.querySelector('[sh-add-to-cart]');
    const modal = document.getElementById('closure-modal')
    let previousVariant = false;
    const quantityFinalEl = document.querySelector('[item-quantity-final]')
    const shrinkBands = ProductShrinkBands();
    const productSubTotal = document.querySelector('[product-sub-total]');



    /**
     * Initialize the component
     */    
    const init = async function(){
        if( elementExists( productClosuresContainer ) 
            &&  currentVariant 
            &&  productVariantMeta 
            &&  productOptions ){
            await shrinkBands.get();
            getCurrentVariantMeta();

            eventBus.on(eventBus.types.OptionsSelected , function( $event ){
                currentVariant = $event.detail;
                getCurrentVariantMeta();
                bundleParentInput.value = currentVariant.id;
            })

            
            if( productOptions ){
                neckFinishPosition = productOptions.findIndex( option => option.name == 'Neck Finish');
                if( neckFinishPosition !== false ){
                    neckFinishes = productOptions[neckFinishPosition].values;
                    if( neckFinishes.length == 1 ){
                        needsClosures = true;
                        getClosures();
                    }
                }
            }
        }        

        modal.addEventListener('hide.bs.modal', event => {
            previousVariant = currentVariant;
        })

        modal.addEventListener('show.bs.modal', event => {
            if( previousVariant !== currentVariant ){
                getClosures();
                selectedClosure = false;
            }
            updateSelectedClosure();
        })

        document.addEventListener('productShrinkBands.acceptChange', function( $event ){
            updateProductSubTotal();
        });


        
    }

    /**
     * use the filter api to get the closures for this variant by neck finish
     */
    const getClosures = function(){
        let neckFinish = currentVariant.options[ neckFinishPosition ];
        let url = '/collections/child-resistant-closures/?view=closure-search&filter.p.product_type=Closure';
        url += '&filter.v.option.neck+finish=' + neckFinish
        url += '&filter.v.option.length=' + currentVariantMeta.length;
        url += '&filter.v.option.pack=Combo';

        fetch( url )
        .then( response => response.text() )
        .then( text => {
            productClosuresContainer.innerHTML = text;
            initClosures();
        });

    }

    /**
     * Initialize the closures interface after ajax request
     */
    const initClosures = function(){
        const closureItems = document.querySelectorAll( '[closure-item]');
        const noClosureItem = document.querySelector( '[no-closure-item]');
        closureItems.forEach( closureItem => {
            closureItem.addEventListener('click', function( $event ){
                $event.preventDefault();
                selectedClosure = closureItem.dataset;
                closureItems.forEach( closureItem => {
                    closureItem.classList.remove( 'selected');
                });
                closureItem.classList.add( 'selected');
                updateSelectedClosure(  );
            });
        });
        noClosureItem.addEventListener('click', function( $event ){
            $event.preventDefault();
            selectedClosure = false;
            closureItems.forEach( closureItem => {
                closureItem.classList.remove( 'selected');
            });
            updateSelectedClosure( true );
        });
        ProductClosureFilters();
    }


    /**
     * Update the display basedon the current closure selection
     * 
     * @param {*} noClosure 
     * @param {*} clear 
     */
    const updateSelectedClosure = function( noClosure =false , clear = false ){
        quantity = quantityFinalEl.value;
        if( selectedClosure ){
            selectedClosureContainer.innerHTML = `
                <input type="hidden" product-closure-selected-id 	name="items[1]id" value="${selectedClosure.id}">
                <input type="hidden" product-closure-selected-quantity name="items[1]quantity" value="${quantity}">
                <input type="hidden" product-closure-selected-quantity name="items[1]properties[_bundle_parent]" value="${currentVariant.id}">
            `
        }else{
            selectedClosureContainer.innerHTML = ``
        }
        shrinkBands.validate( currentVariant, currentVariantMeta , productOptions , selectedClosure, quantity  );
        updatePurchasePreview();

    }

    /**
     * Update the purchase preview based on the current closure selection and the current variant
     */
    const updatePurchasePreview = function(){
        const closurePreviewContainer = document.querySelector('[closure-preview]')
        const purchasePreviewContainer = document.querySelector( '[purchase-preview]')
        let image = currentVariant.featured_image != null ? currentVariant.featured_image.src :  productData.images[0];
        let quantityValue = quantityFinalEl.value;
        let details = `
                <p>${currentVariant.option1} | ${currentVariant.option2} | ${currentVariant.option3} | SKU# ${currentVariant.sku}</p>
            `
        if (selectedClosure) {
          details += `<p>${selectedClosure.title}</p>`
          closurePreviewContainer.innerHTML = `${selectedClosure.title}`
        } else {
          details += `<p>No Closure Selected</p>`
          closurePreviewContainer.innerHTML = `No Closure Selected`
        }
        details += `<p>Quantity : ${quantityValue} Pieces</p>`
        let template = `
            <div class="row product-preview">
              <div class="product-image col-md-3 col-4">
                <div class="product-image--wrapper">
                  <img src="${image}" class="img-fluid" alt="${currentVariant.title}"/>
                </div>
              </div>
              <div class="product-details col-md-9 col-8">${details}</div>
            </div>
            `
        purchasePreviewContainer.innerHTML = template;

        updateProductSubTotal();
    }

    /**
     * Update the product sub total based on the current variant and the selected closure
     */
    const updateProductSubTotal = function(){
        let subTotal = 0;
        subTotal = ( quantityFinalEl.value * currentVariant.price );
        if( selectedClosure ){
            let closureTotal =  ( quantityFinalEl.value   * selectedClosure.price );
            subTotal += closureTotal;
        }
        if( shrinkBands.accepted ){
            let shrinkBandTotal =  ( shrinkBands.quantity * shrinkBands.variant.price );
            subTotal += shrinkBandTotal;
        }
        productSubTotal.innerText = Shopify.formatMoney( subTotal )
    }
    /**
     * The produ t variant meta is an object with the variant id as the key
     */
    const getCurrentVariantMeta = function(){
        if( productVariantMeta ){
            if( productVariantMeta.hasOwnProperty( currentVariant.id )){
                currentVariantMeta = productVariantMeta[ currentVariant.id ];
            }
        }
    }


  

    init();


}

export default ProductClosures;